module.exports = __webpack_public_path__ + "static/media/signage-indoor-img47.5d1099a8.jpg";